import { render } from "./CardiovascularView.vue?vue&type=template&id=0204fd08&scoped=true"
import script from "./CardiovascularView.vue?vue&type=script&lang=js"
export * from "./CardiovascularView.vue?vue&type=script&lang=js"

import "./CardiovascularView.vue?vue&type=style&index=0&id=0204fd08&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0204fd08"]])

export default __exports__